import api from './api';

export const suporteService = {
  enviarMensagem: async (nome, email, mensagem) => {
    try {
      const response = await api.post('/fale-conosco/', {
        nome: nome.trim(),
        email: email.trim().toLowerCase(),
        mensagem: mensagem.trim(),
      });
      return { ok: true, data: response.data };
    } catch (error) {
      const status = error.response?.status;
      const data = error.response?.data;

      if (status === 400) return { ok: false, kind: 'validation', data };
      if (status === 429) return { ok: false, kind: 'rate_limit', data };
      return { ok: false, kind: 'unknown', data };
    }
  },
};